<template>
    <img :src="this.data.big" v-bind:style="{ 'width': width + 'px' }"/>
</template>

<script>
export default {
  props: [
    'data'
  ],
  data () {
    return {
      width: 10
    }
  },
  methods: {

  },
  mounted () {
    this.width = this.data.width * this.GLOBAL.deviceDPI.x / 25.4
    this.$nextTick(() => {
      if (this.data.fontsize && this.data.fontsize != '' && this.$parent.$el && this.$parent.$el.className == 'p') {
        let scale = (355.6 / this.GLOBAL.deviceDPI.x) / this.data.fontsize
        this.width = this.width * scale
        this.height = this.height * scale
      }
    })
  }
}
</script>

<style lang="scss" scoped>
    img{
        vertical-align: baseline;
    }
</style>



// WEBPACK FOOTER //
// src/componentsMobile/maincontent/body/fig/inlinegraphic.vue